import CloseIcon from '@mui/icons-material/Close';
import { Button, IconButton, Stack } from '@mui/material';
import React, { FC } from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import {
    ControlledAutocomplete,
    ControlledCheckbox,
    ControlledInput,
    ControlledNumberInput,
    FormGrid,
    Section,
} from '../../../shared';
import { Gender } from '../../../support/enums';

export const ExpenseTypeInputs: FC = () => {
    const { t } = useTranslation();
    const form = useFormContext();
    const { fields: lumpSums, append, remove } = useFieldArray({ control: form.control, name: 'lumpSums' });
    const watchLumpSum = form.watch('lumpSum');

    return (
        <Stack spacing={2}>
            <Section title={t('data')} sx={{ maxWidth: '400px' }}>
                <ControlledInput name="name" label={t('nameLabel')} required />
                <ControlledCheckbox name="lumpSum" label={t('lumpSum')} />
            </Section>

            {watchLumpSum && (
                <Stack spacing={2}>
                    <ControlledNumberInput
                        name="baseLumpSum"
                        label={t('baseLumpSum')}
                        sx={{ maxWidth: '400px' }}
                        required
                    />

                    {lumpSums.map((lumpSumRule, index) => (
                        <FormGrid key={lumpSumRule.id}>
                            <ControlledNumberInput name={`lumpSums.${index}.startAge`} label={t('startAge')} required />
                            <ControlledAutocomplete
                                name={`lumpSums.${index}.gender`}
                                label={t('genderLabel')}
                                defaultValue="ALL"
                                options={[...Object.values(Gender), 'ALL']}
                                getOptionLabel={(val) => t(val.toLowerCase())}
                            />
                            <ControlledNumberInput
                                name={`lumpSums.${index}.amountPerPerson`}
                                label={t('amountPerPerson')}
                                required
                            />
                            <IconButton onClick={() => remove(index)} size="large">
                                <CloseIcon />
                            </IconButton>
                        </FormGrid>
                    ))}

                    <Button
                        onClick={() => append({ startAge: 0, gender: 'ALL', amountPerPerson: 0 })}
                        color="secondary"
                        sx={{ width: 'fit-content', ml: 2 }}
                    >
                        + {t('addLumpSumRule')}
                    </Button>
                </Stack>
            )}
        </Stack>
    );
};
